export const EVENTS = {
  onboardingStarted: 'OnboardingStarted',
  onboardingStartedSubmitted: 'OnboardingStartedSubmitted',
  onboardingMassmediaShown: 'OnboardingMassmediaShown',
  onboardingMassmediaSubmitted: 'OnboardingMassmediaSubmitted',
  onboardingRoleShown: 'OnboardingRoleShown',
  onboardingRoleSubmitted: 'OnboardingRoleSubmitted',
  onboardingRoleSkip: 'OnboardingRoleSkip',
  onboardingLocationsShown: 'OnboardingLocationsShown',
  onboardingLocationsSubmitted: 'OnboardingLocationsSubmitted',
  onboardingLocationsSkip: 'OnboardingLocationsSkip',
  onboardingReasonShown: 'OnboardingReasonShown',
  onboardingReasonSubmitted: 'OnboardingReasonSubmitted',
  onboardingReasonSkip: 'OnboardingReasonSkip',
  onboardingCheckTimeShown: 'OnboardingCheckTimeShown',
  onboardingCheckTimeSubmitted: 'OnboardingCheckTimeSubmitted',
  onboardingCheckTimeSkip: 'OnboardingCheckTimeSkip',
  onboardingUpdatesShown: 'OnboardingUpdatesShown',
  onboardingUpdatesSubmitted: 'OnboardingUpdatesSubmitted',
  onboardingUpdatesSkip: 'OnboardingUpdatesSkip',
  onboardingInappropriateShown: 'OnboardingInappropriateShown',
  onboardingInappropriateSubmitted: 'OnboardingInappropriateSubmitted',
  onboardingInappropriateSkip: 'OnboardingInappropriateSkip',
  onboardingQuantityShown: 'OnboardingQuantityShown',
  onboardingQuantitySubmitted: 'OnboardingQuantitySubmitted',
  onboardingQuantitySkip: 'OnboardingQuantitySkip',
  onboardingFeatureListShown: 'OnboardingFeatureListShown',
  onboardingFeatureListSubmitted: 'OnboardingFeatureListSubmitted',
  onboardingFeatureListSkip: 'OnboardingFeatureListSkip',
  OnboardingReceivedAnswersShown: 'OnboardingReceivedAnswersShown',
  onboardingReceivedAnswersSubmitted: 'OnboardingReceivedAnswersSubmitted',
  onboardingCheckLocation: 'OnboardingCheckLocation',
  onboardingCheckLocationSubmitted: 'OnboardingCheckLocationSubmitted',
  onboardingPlacesShown: 'OnboardingPlacesShown',
  onboardingPlacesSubmitted: 'OnboardingPlacesSubmitted',
  onboardingArSearchShown: 'OnboardingArSearchShown',
  onboardingArSearchSubmitted: 'OnboardingArSearchSubmitted',
  onboardingSosShown: 'OnboardingSosShown',
  onboardingSosSubmitted: 'OnboardingSosSubmitted',
  onboardingPlatformsShown: 'OnboardingPlatformsShown',
  onboardingPlatformsSubmitted: 'OnboardingPlatformsSubmitted',
  onboardingEnterEmailShown: 'OnboardingEnterEmailShown',
  onboardingEnterEmailSubmitted: 'OnboardingEnterEmailSubmitted',
  onboardingQuestionPageSubmitted: 'question_page_completed',
  onboardingFactPageSubmitted: 'fact_page_completed',
  signupSuccess: 'AccountCreated',
  creatingProfileShown: 'CreatingProfileShown',
  onboardingPaywallShown: 'OnboardingPaywallShown',
  onboardingPaywallChosen: 'OnboardingPaywallChosen',
  onboardingCheckoutShown: 'OnboardingCheckoutShown',
  subBuyTapped: 'SubBuyTapped',
  subscribed: 'PaywallSubscribed',
  subBuyClosed: 'PaywallClosed',
  cardMethodChosen: 'CardCheckoutChosen',
  paymentAnimationScreen: 'PaymentAnimationScreen',
  onboardingPaymentDecline: 'OnboardingPaymentDecline',
  onboardingDeclineTryAgain: 'OnboardingDeclineTryAgain',
  upsellView: 'UpsellView',
  upsellTapped: 'UpsellTapped',
  upsellTappedClose: 'UpsellCloseTapped',
  upsellPurchased: 'UpsellPurchased',
  upsellFailed: 'UpsellPurchasedFailed',
  onboardingSuccessShown: 'OnboardingSuccessShown',
  onboardingDone: 'OnboardingDone',
};
